import React from 'react';
import i18n from '../../locales/index';
import { Row, Col, Container } from 'react-bootstrap'
import './index.css'
import TitleBold from '../../components/Text/TitleBold';
import MainStyles from '../../styles/MainStyles';
import ServiceCard from '../ServiceCard';
import {defineServiceCompletedLabel, toOrdinalPrefix} from '../../services/History'
import TitleLight from '../Text/TitleLight';

const ServiceHistory = ({ serviceList, isFreeReview }) => {
  return (
    <Container fluid="md">
      <Row className='row-service-history'>
        <Col md={{span: 12}}>
        <Row>
          <Col>
            <TitleBold
              text={i18n.t('service_history.title')}
              color={MainStyles.colors.black}
              ownClass={'service_text service_history_title'}
              size={'big'} />
          </Col>
        </Row>
        <Row className='service-history-list'>
          { serviceList.length > 0 ?
              serviceList.map((mapped, index) => (
                <ServiceCard
                  key={`card-${mapped.vehicleServicingType}${index}`}
                  vehicleServicingDate={mapped.vehicleServicingDate}
                  vehicleServicingMileage={mapped.vehicleServicingMileage}
                  workDescription={`${toOrdinalPrefix(serviceList.length - index)} ${i18n.t('service_history.revision')}`}
                  vehicleServicingType={serviceList.length - index}
                  vehicleServicingActiveStamp={mapped.vehicleServicingActiveStamp}
                  hasBorder={(index +1) % 2 === 0}
                  labelCompletedService={defineServiceCompletedLabel(serviceList, mapped)}
                  isFreeReview={isFreeReview}
                  orderService={index+1}
                />
              ))
            :
              <Col style={{paddingBottom: '32px'}}>
                <TitleLight
                  text={i18n.t('service_history.no_revisions')}
                  color={MainStyles.colors.black}/>
              </Col>
          }
        </Row>
        </Col>
      </Row>
    </Container>
  )
}

export default ServiceHistory
